import { computed } from '@angular/core';
import {
  patchState,
  signalStoreFeature,
  withComputed,
  withMethods,
  withProps,
  withState,
} from '@ngrx/signals';
import { Team, User } from '@seatix/shared/domain';
import {
  injectIsUserResourceActive,
  injectUserResource,
} from '../resources/user.resource';

export function withUserResource() {
  return signalStoreFeature(
    withState<{ user: User | null; current_team: Team | null }>({
      user: null,
      current_team: null,
    }),
    withProps(() => ({
      _userResource: injectUserResource(),
      _isResourceActive: injectIsUserResourceActive(),
    })),
    withProps(({ _userResource }) => ({
      userResource: _userResource.asReadonly(),
    })),
    withComputed(({ user }) => {
      const isEmailVerified = computed(() => !user()?.needs_email_verification);
      return {
        isEmailVerified,
      };
    }),
    withMethods((store) => ({
      setUser: function (user: User) {
        store._userResource.set(user);
        const firstTeam =
          user.teams && user.teams.length > 0 ? user.teams[0] : null;
        patchState(store, {
          user,
          current_team: firstTeam,
        });
      },
      clearUser: function () {
        store._userResource.destroy();
        patchState(store, {
          user: undefined,
          current_team: null,
        });
      },
      setCurrentTeam: function (team: Team) {
        patchState(store, {
          current_team: team,
        });
      },
      setResourceActive: function (isActive: boolean) {
        store._isResourceActive.set(isActive);
      },
      reloadUser: function () {
        store._userResource.reload();
      },
    })),
  );
}
